import {remCalc} from '../../_utils'

export default {
    baseStyle: ({
        isSmallTablet,
        slidersLength,
        hasPaddings,
    }: {
        isSmallTablet: boolean
        slidersLength: number
        hasPaddings: boolean
    }) => ({
        container: {
            maxW: remCalc(1920),
            mx: 'auto',
            py: hasPaddings ? {base: remCalc(24), md: remCalc(24), lg: remCalc(40)} : 'unset',
            width: '100%',
        },
        chevronIcon: {
            width: remCalc(32),
            height: remCalc(32),
            position: 'absolute',
            backgroundColor: 'background.default',
            borderRadius: '50%',
            transform: 'translateY(-100%)',
            cursor: 'pointer',
            zIndex: '10',
            top: isSmallTablet ? '53%' : {base: '52%', md: '53%'},
        },
        outterCardContainer: {
            paddingLeft: {base: remCalc(16), md: remCalc(24), lg: 0}, //isSmallTablet ? remCalc(16) :
            paddingRight:
                slidersLength < 3
                    ? isSmallTablet
                        ? remCalc(16)
                        : {md: remCalc(16), lg: remCalc(0)}
                    : '',
        },
        cardContainer: {
            overflow: 'hidden',
            bgSize: 'cover',
            bgPos: 'center',
            bgRepeat: 'no-repeat',
            w: '100%',
            height: isSmallTablet ? remCalc(410) : {base: remCalc(400), md: remCalc(560)},
            position: 'relative',
            cursor: 'auto',
        },
        textContentContainer: {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-end',
            w: '100%',
            padding: isSmallTablet ? remCalc(24) : {base: remCalc(24), md: remCalc(40)},
        },
        moodboardButton: {
            variant: 'inverse',
        },
        moodboardTextTitleDescription: {
            mb: {base: remCalc(16), md: remCalc(16), lg: remCalc(16), xl: remCalc(24)},
            titleSpacing: {
                base: remCalc(16),
                md: remCalc(16),
                lg: remCalc(16),
                xl: remCalc(24),
            },
            textStyle: 'head-small',
            color: 'text.inverse',
            fontWeight: 'medium',
            childrenTextStyle: 'body-medium',
            childrenTextColor: 'text.inverse',
            _focusVisible: {
                border: 'large',
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
            },
        },
        moodboardChevronIcon: {
            backgroundColor: 'background.default',
            borderRadius: '50%',
        },
        moodboardButtonText: {
            color: 'text.inverse',
            textStyle: 'body-medium',
        },
        moodboardButtonStack: {
            gap: remCalc(10),
            textDecoration: 'none',
        },
    }),
}
